import { Box, Grid, useMediaQuery } from "@mui/material"
import i18n from "i18n-js"
import { InputAutoComplete, InputForm } from "../../../../components"
import { useStyles } from "./styles"

export const ListFilter = ({ lists, handleChange, values }) => {
    const { styles } = useStyles()
    const hidden = useMediaQuery(theme => theme.breakpoints.up('md'));
    return (
        <Grid container spacing={1} justifyContent={"end"}>

            <Grid item xl={4} lg={4} md={5} sm={6} xs={12}>
                <Box sx={styles.dates}>
                    <InputForm
                        color="secondary"
                        clear
                        onChange={() => { }}
                        onAccept={(value) => {
                            if (value !== null && value !== values.start) {
                                handleChange(value || null, "start");
                            }
                        }}
                        name="start"
                        label={i18n.t("general.from")}
                        fullWidth
                        value={values?.start || null}
                        error={false}
                        date
                        sx={styles.autocomplete}
                        allDate
                        // 👇 si existe end, limita el start hasta esa fecha
                        maxDate={values?.end || undefined}
                    />

                    {
                        hidden && (
                            <InputForm
                                color="secondary"
                                clear
                                onChange={() => { }}
                                onAccept={(value) => {
                                    if (value !== null && value !== values.end) {
                                        handleChange(value || null, "end");
                                    }
                                }}
                                name="end"
                                label={i18n.t("general.to")}
                                fullWidth
                                value={values?.end || null}
                                error={false}
                                date
                                allDate
                                // 👇 si existe start, limita el end desde esa fecha
                                minDate={values?.start || undefined}
                                sx={styles.autocomplete}
                            />
                        )
                    }
                </Box>
            </Grid>

            {!hidden && <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
                <InputForm
                    color="secondary"
                    clear
                    onChange={() => { }}
                    onAccept={(value) => {
                        if (value !== null && value !== values.end) {
                            handleChange(value || null, "end");
                        }
                    }}
                    name="end"
                    label={i18n.t("general.to")}
                    fullWidth
                    value={values?.end || null}
                    error={false}
                    date
                    allDate
                    // 👇 si existe start, limita el end desde esa fecha
                    minDate={values?.start || undefined}
                    sx={styles.autocomplete}
                />
            </Grid>}

            {/* <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
                <InputAutoComplete
                    value={values?.staff || null}
                    label={i18n.t("general.staff")}
                    onChange={(e, value) => {
                        handleChange(value, "staff")
                    }}
                    options={lists.staff || []}
                    renderOption={(props, option, index) => {
                        const key = `listItem-${index}-${option.id}`

                        return option.label ? (
                            <li {...props} key={key}>
                                {option.label}
                            </li>
                        ) : (
                            ''
                        )
                    }}
                    sx={styles.autocomplete}
                    getOptionLabel={(val) => val.label ?? ''}
                />
            </Grid> */}

            <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
                <InputAutoComplete
                    value={values?.patient || null}
                    label={i18n.t("general.patient")}
                    onChange={(e, value) => {
                        handleChange(value, "patient")
                    }}
                    options={lists.patient || []}
                    renderOption={(props, option, index) => {
                        const key = `listItem-${index}-${option.id}`

                        return option.label ? (
                            <li {...props} key={key}>
                                {option.label}
                            </li>
                        ) : (
                            ''
                        )
                    }}
                    getOptionLabel={(val) => val.label ?? ''}
                    sx={styles.autocomplete}
                />
            </Grid>
        </Grid>
    )
}